import React from 'react';

const HEBREW = /[\u0590-\u05FF]/;
const LATIN = /[A-Za-z]/;

/**
 * Matches LTR runs: parenthesized English/address segments, or Latin/digit-led runs
 * (addresses, times like "7:30 pm", English phrases).
 */
const LTR_RUN =
  /(\([A-Za-z0-9\s\-.,#@/&'"]*\)|[A-Za-z0-9][A-Za-z0-9\s\-.,#@()/'":&]*)/g;

/**
 * Wraps Latin-script runs in {@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/bdi `<bdi dir="ltr">`}
 * when the string mixes Hebrew and Latin, so addresses and English fragments render left-to-right inside RTL UI.
 *
 * @param {string|null|undefined} text
 * @returns {React.ReactNode}
 */
export function bidiText(text) {
  if (text == null || text === '') {
    return text;
  }
  const str = String(text);
  if (!HEBREW.test(str) || !LATIN.test(str)) {
    return str;
  }

  const nodes = [];
  let lastIndex = 0;
  let m;
  let keyIdx = 0;
  LTR_RUN.lastIndex = 0;
  while ((m = LTR_RUN.exec(str)) !== null) {
    if (m.index > lastIndex) {
      nodes.push(str.slice(lastIndex, m.index));
    }
    nodes.push(
      React.createElement('bdi', { dir: 'ltr', key: `bdi-${keyIdx++}` }, m[0])
    );
    lastIndex = m.index + m[0].length;
  }
  if (lastIndex < str.length) {
    nodes.push(str.slice(lastIndex));
  }
  return React.createElement(React.Fragment, null, ...nodes);
}
